const parseList = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (typeof value !== "string" || !value.trim()) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
  } catch {
    return [];
  }
};

export const summarizePlanningRoute = (pedidos = []) => {
  const routeItem = pedidos.find((item) => Number(item?.rota_total_grupos) > 0)
    || pedidos.find((item) => item?.rota_operacional_id)
    || {};
  const groups = parseList(routeItem.vans_planejamento);
  if (groups.length) return {
    vanCount: groups.length,
    vans: groups.map((group, index) => ({ index, groupId: group.planejamento_grupo_id || null, numero: Number(group.planejamento_van_numero) || index + 1, conferida: Boolean(group.conferida), motorista: group.motorista?.nome || null,
      veiculo: group.veiculo ? `${group.veiculo.veiculo} (${group.veiculo.placa})` : null,
      regiao: group.regiao || null,
      passageiros: group.pessoas?.length || 0,
      pronta: Boolean(group.motorista?.id && group.veiculo?.id && group.pessoas?.length
        && group.pessoas.length <= Number(group.veiculo.capacidade || 15)),
    })),
  };
  const motoristas = parseList(routeItem.rota_motoristas);
  const veiculos = parseList(routeItem.rota_veiculos);
  const persistedCount = Number(routeItem.rota_total_grupos);
  const vanCount = Number.isInteger(persistedCount) && persistedCount > 0
    ? persistedCount
    : Math.max(motoristas.length, veiculos.length, 0);

  return {
    vanCount,
    vans: Array.from({ length: vanCount }, (_, index) => ({
      index,
      motorista: motoristas[index] || null,
      veiculo: veiculos[index] || null,
    })),
  };
};
